export default __webpack_public_path__ + "static/media/line9.6bae0408.svg";